import script from "./GeminiModel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeminiModel.vue?vue&type=script&setup=true&lang=ts"

import "./GeminiModel.vue?vue&type=style&index=0&id=1e020045&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e020045"]])

export default __exports__